export enum TypePersonEnum {
    LEGAL_PERSON = 'Jurídica',
    NATURAL_PERSON = 'Física',
    FOREIGN_PERSON = 'Estrangeira',
}

export type TypePerson = 'LEGAL_PERSON' | 'NATURAL_PERSON' | 'FOREIGN_PERSON';
